module.exports = __webpack_public_path__ + "static/img/page_Title.51e4d3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/_course/series6-moocs/course3/page_Title.jpg
// module id = 96vx
// module chunks = 0